import Splide from '@splidejs/splide'
import '@splidejs/splide/css/core';
export default function Sliders() {
	// --- Notice Slider ---
	const noticeElement = document.querySelector('.js-notices-slider')

	if (noticeElement) {
		const notice = new Splide('.js-notices-slider', {
			type: 'loop',
			arrows: true,
			gap: 20,
			pagination: false,
			keyboard: false,
			drag: true,
			autoplay: true,
			speed: 1000,
			interval: 5000,
			pauseOnHover: false,
			snap: true,
			classes: {
				arrows: 'splide__arrows',
				arrow: 'splide__arrow',
				prev: 'splide__arrow--prev',
				next: 'splide__arrow--next',
			},
		}).mount()

		notice.on('move', function(){
			const index = notice.index
			const noticeIndex = document.querySelector('.js-notice-index')
			noticeIndex.innerHTML = index + 1
		});
	}

	// --- Gallery Slider ---
	const galleryElement = document.querySelectorAll('.js-gallery-slider')

	if (galleryElement.length) {
		galleryElement.forEach(element => {
			const gallery = new Splide(element, {
				type: 'loop',
				arrows: true,
				pagination: false,
				keyboard: false,
				drag: true,
				autoplay: true,
				speed: 1000,
				interval: 5000,
				pauseOnHover: false,
				snap: true,
				perPage: 1,
				mediaQuery: 'min',
				center: true,
				focus: 'center',
				breakpoints: {
				},
				classes: {
					arrows: 'splide__arrows',
					arrow: 'splide__arrow',
					prev: 'splide__arrow--prev',
					next: 'splide__arrow--next',
				},
			}).mount()

			gallery.on('move', function(){
				const index = gallery.index
				const galleryIndex = gallery.root.querySelector('.js-gallery-index')
				galleryIndex.innerHTML = index + 1
			});
		});
	}

		
		const testimonialElement = document.querySelectorAll('.js-testimonial-slider')

	if (testimonialElement.length) {
		testimonialElement.forEach(element => {
			const testimonial = new Splide(element, {
				type: 'loop',
				arrows: true,
				pagination: false,
				keyboard: false,
				drag: true,
				pauseOnHover: false,
				snap: true,
				perPage: 1,
				mediaQuery: 'min',
				center: true,
				focus: 'center',
				speed: 1000,
				breakpoints: {
				},
				classes: {
					arrows: 'splide__arrows',
					arrow: 'splide__arrow',
					prev: 'splide__arrow--prev',
					next: 'splide__arrow--next',
				},
			}).mount()

			testimonial.on('move', function(){
				const index = testimonial.index
				const testimonialIndex = testimonial.root.querySelector('.js-testimonial-index')
				testimonialIndex.innerHTML = index + 1
			});
		});
	}
}
